/**
 * Backwards-compatibility shim for useSitecoreContext (JSS API).
 *
 * CSDK replaced `useSitecoreContext()` with `useSitecore()`, which returns { page, api }.
 * This shim re-exports the same `{ sitecoreContext }` shape so component files that call
 *   const { sitecoreContext } = useSitecoreContext();
 * continue to compile without modification.
 *
 * sitecoreContext is the LayoutServiceContext from page.layout.sitecore.context, cast to
 * a loose Record type so custom server-side fields (siteSettings, breadcrumbData, etc.)
 * are accessible without type errors.
 */
import { LayoutServiceContext, useSitecore } from '@sitecore-content-sdk/nextjs';

export function useSitecoreContext(): { sitecoreContext: LayoutServiceContext } {
  const { page } = useSitecore();
  const sitecoreContext = page?.layout?.sitecore?.context ?? {};
  return { sitecoreContext };
}
